import { Moment } from '@intelipost-js/secure-providers';

export default {
  dateSource: 'EXPIRATION_DATE',
  dateRange: {
    start: Moment().subtract(15, 'days').format('YYYY-MM-DD'),
    end: Moment().format('YYYY-MM-DD'),
  },
  warehouseFilter: [],
  totalizers: [
    { field: 'billingsCount' },
    { field: 'billingsTotalValue', isCurrency: true },
    { field: 'shipmentOrdersCount' },
    { field: 'divergentBillingsCount' },
    { field: 'divergentBillingsTotalValue', isCurrency: true, label: 'O valor total da divergência é a soma total de todas as divergências identificadas no período selecionado.' },
  ],
  billingsByLogisticProvider: [],
  loadingBillingsTable: false,
  logisticProviderBillingDetails: [],
  loadingBillingDetails: false,
  singleBillingTemplate: {},
  clientBillingTemplates: [],
  loadingBillingTemplates: false,
  billingUploadFiles: [],
  billingExtractionFiles: [],
  loadingBillingFiles: false,
  savingBillingUpload: false,
  savingBillingUploadError: false,
  loadingExtractDetail: false,
  loadingBillingTemplatePreview: false,
  savingBillingTemplate: false,
  savingBillingTemplateError: false,
  previewMap: {},
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/billing/store/states.js